import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=6ac33094&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&lang=ts"
export * from "./QuestionDialog.vue?vue&type=script&lang=ts"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=6ac33094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac33094",
  null
  
)

export default component.exports